import { Link } from "@tanstack/react-router";
import { Quote, ChevronRight } from "lucide-react";
import type { QuoteTopic } from "@/routes/innovation-days-demo/types";

interface QuotesContentProps {
  topics: QuoteTopic[];
}

export function QuotesContent({ topics }: QuotesContentProps) {
  // Calculate global quote index across all topics
  let globalQuoteIndex = 0;

  return (
    <div className="space-y-6">
      {topics.map((t) => (
        <div key={t.topic} className="relative pl-4">
          {/* Left accent bar */}
          <div
            className="absolute left-0 top-0 bottom-0 w-1 rounded-full"
            style={{ background: "#6366F1" }}
          />

          {/* Topic header */}
          <div className="mb-4">
            <div className="flex items-center gap-2">
              <Quote className="w-3.5 h-3.5" style={{ color: "#6366F1" }} />
              <h4
                className="text-[14px] leading-[20px] font-semibold"
                style={{ color: "#0F172A" }}
              >
                {t.topic}
              </h4>
            </div>
          </div>

          {/* Quotes list */}
          <div className="space-y-1.5">
            {t.quotes.map((q) => {
              const currentIndex = globalQuoteIndex;
              globalQuoteIndex += 1;
              return (
                <Link
                  key={`${t.topic}-${q.evidence.paragraph_index}-${q.evidence.start_sentence_index_within_paragraph}`}
                  to="/innovation-days-demo/viewer"
                  search={{
                    annotationType: "quote",
                    annotationIndex: currentIndex,
                  }}
                  className="group block py-2.5 rounded-lg cursor-pointer transition-colors"
                >
                  <div className="flex items-start gap-3">
                    {/* Quote text in serif */}
                    <div className="flex-1 min-w-0">
                      <p
                        className="text-[15px] leading-[22px]"
                        style={{
                          color: "#475569",
                          fontFamily: 'Georgia, "Times New Roman", serif',
                        }}
                      >
                        &ldquo;{q.text}&rdquo;
                      </p>
                    </div>

                    {/* Arrow with label */}
                    <div className="flex items-center gap-1.5 flex-shrink-0">
                      <span
                        className="text-[12px] font-medium opacity-0 group-hover:opacity-100 transition-opacity hidden sm:block"
                        style={{ color: "#6366F1" }}
                      >
                        View in Text
                      </span>
                      <ChevronRight
                        className="w-4 h-4 transition-transform group-hover:translate-x-0.5"
                        style={{ color: "#6366F1" }}
                      />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
